<template>
  <v-app>
    <Topmenubar :breadcrumbs="this.breadcrumb" />
    <v-main class="bg-white">
    <v-container>
 
    <v-card
      elevation="0"
      class="h-100 py-5 px-2 pa-md-10 rounded-xl"
      color="white align-center"
    >
   

      <v-stepper v-model="e1" elevation="0" class="elevation-0">
        <v-stepper-items>
          <v-stepper-content step="1">
            <h4
              v-text="'Nieuwe businesscard'"
              color="primary"
              class="
                headline
                font-weight-bold
                text-center
                mx-auto
                d-block
                text-primary
              "
            ></h4>
            <p class="text-center">
              Bestel een nieuwe fysieke card of registeer je nieuwe card
            </p>
            <v-img
              class="m-auto mb-3"
              max-width="300"
              max-height="500"
              src="../../assets/kyano-card-illustration-people.svg"
            ></v-img>

            <v-spacer class="my-10"></v-spacer>
            <v-btn
              color="secondary"
              class="mb-3"
              large
              block
              elevation="0"
              @click="e1 = 2"
            >
              Registreren
            </v-btn>
            <v-btn color="bg_light" large block elevation="0" href="">
              Nieuwe card bestellen
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-subheader
              v-text="'Wat is je pasnummer?'"
              color="primary"
              class="headline font-weight-bold text-left pa-0 ma-0 text-primary"
            ></v-subheader>
            <p class="text-left">Dit is te vinden op de voorkant van je pas.</p>

            <v-text-field
              label="Pasnummer"
    
              outlined
            ></v-text-field>

            <v-btn color="secondary" large block elevation="0" @click="e1 = 3">
              Volgende
            </v-btn>

            <v-btn
              class="mt-3"
              small
              color="primary"
              dark
              text
              append
              @click="e1 = 1"
            >
              <v-icon color="primary">mdi-arrow-left</v-icon> Vorige stap
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-subheader
              v-text="'Kies je profiel'"
              color="primary"
              class="headline font-weight-bold text-left pa-0 ma-0 text-primary"
            ></v-subheader>
            <p class="text-left">
              Selecteer een bestaande profiel of maak een nieuwe aan.
            </p>

   
            <v-btn large block color="primary" elevation="0" class="mb-3"
              >Profiel aanmaken</v-btn
            >

            <v-btn
              color="secondary"
              large
              block
              elevation="0"
              @click="dialog = false"
            >
              Mijn card activeren
            </v-btn>
            <v-btn
              class="mt-3"
              small
              color="primary"
              dark
              text
              append
              @click="e1 = 2"
            >
              <v-icon color="primary">mdi-arrow-left</v-icon> Vorige stap
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
</v-container>
    </v-main>
  </v-app>
</template>
<script>

import Topmenubar from '../../components/Topmenubar.vue';

export default {
  components: {
    Topmenubar,
  },

  data: () => ({
    e1: 1,
    breadcrumb: [
      {
        text: "Support",
        disabled: true,
        href: "/support",
      },
    ],
  }),
};
</script>
